export function getParameterByName(name, url) {
	if (!url) {
		url = window.location.href;
	}
	name = name.replace(/[\[\]]/g, '\\$&');

	const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
	const results = regex.exec(url);

	if (!results) {
		return null;
	}

	if (!results[2]) {
		return '';
	}

	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getValuesFromULState(keys, url) {
	let queryStringObj = {};
	keys.forEach((key) => {
		queryStringObj[key] = getParameterByName(key, url);
	});
	return queryStringObj;
}

export function getParametersFromUrl(url) {
	if (!url) {
		url = window.location.href;
	}
	
	let search = location.search.substring(1);
	if (search !== '') {
		return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(new RegExp('=', 'g'), '":"') + '"}');
	}
	return {};
}



// WEBPACK FOOTER //
// ./utility/queryStringHelper.js